import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import TestingGate from "./components/TestingGate";
import "./index.css";
import { installAudioUnlock } from "./games/shared/sound";
import { installNetworkGuard } from "./lib/networkGuard";
import { installFrameGuard } from "./lib/frameGuard";

// Privacy: install before anything else can issue requests.
installNetworkGuard();
// Clickjacking: defense-in-depth on top of edge X-Frame-Options / frame-ancestors.
installFrameGuard();
installAudioUnlock();

// Testing gate is disabled until 2026-07-04T12:00:00 local time.
const GATE_ENABLE_AT = new Date(2026, 6, 4, 12, 0, 0).getTime();
const gateActive = Date.now() >= GATE_ENABLE_AT;

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    {gateActive ? (
      <TestingGate>
        <App />
      </TestingGate>
    ) : (
      <App />
    )}
  </HelmetProvider>,
);
